import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> Resin Bookmarks </h1>

    
    <div className="imgs max800">
        <div>
            <img src={require('../assets/craft/resin/onBook/oldThree_v2.jpg')} data-skip-gallery/>
        </div>
    </div>

    <h2>Process</h2>


    <p>Firstly, I collected various flowers and leaves over the span of a few weeks, 
    selecting ones that varied in shape and color. Then, I pressed them in heavy books.</p>
    <div className="imgs max800">
        <div>
            <img src={require('../assets/craft/resin/process/near.JPG')} data-skip-gallery/>
        </div>
    </div>

    <p>I laid out all of my collected pressed flowers, and played around with the layout 
    I wanted for each bookmark, fitting them to the bookmark casts.</p>

    <div className="imgs max800">
        <div>
            <img src={require('../assets/craft/resin/process/laying_v2.jpg')} data-skip-gallery/>
        </div>
    </div>

    <p>I temporarily removed the flowers from the casts to lay a base layer of resin. Then I 
    placed the flowers back in their determined locations and set with a top layer of resin.</p>


    <h2>Completed Bookmarks</h2>

    

    <div className="imgs max800">
        <div>
            <img src={require('../assets/craft/resin/onBook/yellow.JPG')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/craft/resin/onBook/paw.JPG')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/craft/resin/onBook/bigPurple.JPG')} data-skip-gallery/>
        </div>
    </div>

    <div className="imgs max800">
        <div>
            <img src={require('../assets/craft/resin/onBook/bigBlue.JPG')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/craft/resin/onBook/lilPurple.JPG')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/craft/resin/onBook/esays.JPG')} data-skip-gallery/>
        </div>
    </div>

    <div className="imgs max800">
        <div>
            <img src={require('../assets/craft/resin/onBook/bigColorful.jpg')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/craft/resin/onBook/red_v2.jpg')} data-skip-gallery/>
        </div>
        <div>
            <img src={require('../assets/craft/resin/onBook/lilGreen.jpeg')} data-skip-gallery/>
        </div>
    </div>




    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.